import { render, staticRenderFns } from "./CrmAuthConnectLayout.vue?vue&type=template&id=c81a9ea2&scoped=true"
import script from "./CrmAuthConnectLayout.vue?vue&type=script&lang=js"
export * from "./CrmAuthConnectLayout.vue?vue&type=script&lang=js"
import style0 from "./CrmAuthConnectLayout.vue?vue&type=style&index=0&id=c81a9ea2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81a9ea2",
  null
  
)

export default component.exports